import { api } from "../lib/api";

// finalLookEngine.generateFinalLook(payload)
export async function generateFinalLook(payload) {
  const {
    userPhoto, occasion, styleDirection,
    selectedHairstyle, selectedOutfit, selectedAccessories, selectedProducts,
    productImageUrl, productTitle,
  } = payload;
  const image_base64 = (userPhoto || "").split(",")[1] || userPhoto;
  const { data } = await api.post("/ai/generate-look", {
    image_base64,
    occasion,
    styleDirection,
    hairstyle: selectedHairstyle,
    outfit: selectedOutfit,
    accessories: selectedAccessories,
    products: selectedProducts,
    product_image_url: productImageUrl,
    product_title: productTitle,
  });
  return data; // { image, caption }
}
